import { useEffect, useCallback } from 'react'

const useEffectWhenCondition = (conditionFn, callback, dependencies = [], timeout = 5000) => {
    
    const checkCondition = useCallback(async () => {
        
        try {
            
            if (await conditionFn())
                return true
            
        } catch (e) {
            
            console.error('useEffectWhenCondition: failed to check condition', e)
            return false
            
        }
        
        return false
        
    }, [conditionFn])
    
    useEffect(() => {
        
        const startTime = Date.now()
        
        const interval = setInterval(async () => {
            
            if (await checkCondition()) {
                
                clearInterval(interval)
                await callback()
                
            } else if (Date.now() - startTime >= timeout) {
                
                clearInterval(interval)
                console.error(`Timeout: condition failed available after ${timeout / 1000} seconds.`)
                
            }
        }, 100) // Check every 100ms
        
        return () => clearInterval(interval) // Cleanup on unmount
        
    }, [conditionFn, callback, timeout, ...dependencies])
    
}

export default useEffectWhenCondition
